import {ArrowLeftOutlined, ArrowRightOutlined} from "@ant-design/icons";
import React from "react";

export function Arrows({
    goToPrev,
    goToNext,
    isHidden,
}) {
    // const debouncedGoToPrev = useMemo(
    //     () => debounce(goToPrev, 300, {leading: true, trailing: false}), [goToPrev],
    // );
    // const debouncedGoToNext = useMemo(
    //     () => debounce(goToNext, 300, {leading: true, trailing: false}), [goToNext],
    // );

    if (!isHidden) {
        return (
            <>
                <ArrowLeftOutlined className="lightbox-btn arrow-left" onClick={goToPrev} />
                <ArrowRightOutlined className="lightbox-btn arrow-right" onClick={goToNext} />
            </>
        );
    }
    return null;
}
